import { data as opthomology } from "./opthomology";
import { data as ortho } from "./ortho";
import { data as pediatrics } from "./pediatrics";
import { data as gyno } from "./gyno";
import { data as dermatology } from "./derma";
import { data as internalMed } from "./internalMedicine";
import { data as dibetology } from "./diabetology";
import { data as generalSurgery } from "./generalSurgery";
import { data as ent } from "./ent";
import { data as cardio } from "./cardio";
import { data as nephrology } from "./nephrology";
import { data as neurology } from "./neurology";
import { data as physio } from "./physio";
import { data as gastro } from "./gastroenterology";
import { data as radiology } from "./radiology";
import { data as criticalCare } from "./criticalCare";

export const department = {
  opthomology: opthomology,
  ophthalmology: opthomology,
  ortho: ortho,
  pediatrics: pediatrics,
  gyno: gyno,
  dermatology: dermatology,
  internalMedicine: internalMed,
  dibetology: dibetology,
  generalSurgery: generalSurgery,
  ent: ent,
  cardio: cardio,
  nephrology: nephrology,
  neurology: neurology,
  physio: physio,
  gastro: gastro,
  radiology: radiology,
  criticalCare: criticalCare,
};
